import { Box } from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiTypography from "@mui/material/Typography";
import styled from "styled-components";

export const DialogTitle = styled(MuiDialogTitle)`
  color: #263238;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: "NotoSans-SemiBold";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const ActionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const Typography = styled(MuiTypography)<{ color?: string }>`
  color: ${(props) => props.color || props.theme.text.primary};
  font-size: 16px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const FinePrint = styled(MuiTypography)<{ color?: string }>`
  color: ${(props) => props.color || props.theme.text.secondary};
  font-size: 12px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 100;
  line-height: 15px;
`;

export const Content = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  height: fit-content;
  overflow-x: auto;
  gap: 10px;
  padding: 10px 18px 5px 18px;
  border-radius: 10px 10px 10px 10px;
  background: var(--colours-primary-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
`;
